import {useAuthContext} from '../providers/AuthProvider'

export const useUser = () => {
  const {user} = useAuthContext()
  return user
}
